import {get} from "vuex-pathify";
export default {
    computed: {
        meta: get('form/resource_form@comment'),
        home_hero_desktop_image(){
            return _.get(this.meta,'home_hero_desktop_image')
        },
        home_hero_mobile_image(){
            return _.get(this.meta,'home_hero_mobile_image')
        },
        home_hero_alt(){
            return _.get(this.meta,'home_hero_alt')
        },
        form_side_image(){
            return _.get(this.meta,'form_side_image')
        },
        home_hero_desktop_video(){
            return _.get(this.meta,'home_hero_desktop_video')
        },
        home_hero_mobile_video(){
            return _.get(this.meta,'home_hero_mobile_video')
        },
        hero_is_video(){
            return _.get(this.meta,'hero_is_video')
        },
        extra_class_nl_2025_2eur(){
            return _.get(this.meta,'extra_class_nl_2025_2eur', false)
        },
        box(){
            return _.get(this.meta,'box')
        },
        box_list(){
            let raw_gifts = _.split(_.get(this.meta,'box_list'), '|');
            _.forEach(raw_gifts, (gift,giftIndex)=>{
                raw_gifts[giftIndex] = _.split(gift, ',');
            })
            return raw_gifts;
        },
        service_image(){
            return _.get(this.meta,'service_image', 'https://euroconsumers.fra1.digitaloceanspaces.com/testaankoop/2025/MG-hover-032025/illu.png')
        },
        service_image_mobile(){
            return _.get(this.meta,'service_image_mobile', 'https://euroconsumers.fra1.digitaloceanspaces.com/testaankoop/2025/MG-hover-032025/illu-m.png')
        },
        economy_amount(){
            return _.get(this.meta,'economy_amount', '2300');
        },
        has_composition_tag() {
            return _.get(this.meta, 'has_composition_tag', false);
        },
        is_meta_dropdown(){
            return _.get(this.meta, 'is_dropdown', false);
        },
        gift_choice(){
            let raw_gifts = _.split(_.get(this.meta, 'gift_choice'), '|');
            let gifts_obj = {};

            _.forEach(raw_gifts, (gift) => {
                let parts = _.split(gift, ',');
                let gift_key = parts[0];
                let gift_string = parts[1];
                gift_key = gift_key.replace('\n', '');
                gift_string = gift_string.replace('\n', '');
                gifts_obj[gift_key] = gift_string;
            });

            return gifts_obj;
        },
    },
    methods: {

    },
}
